import { render, staticRenderFns } from "./BindsCheckbox.vue?vue&type=template&id=695ab0d2&"
import script from "./BindsCheckbox.vue?vue&type=script&lang=js&"
export * from "./BindsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BindsCheckbox.vue?vue&type=style&index=0&id=695ab0d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports